module.exports = __webpack_public_path__ + "static/img/joinus.3219f64f.png";